import React, { ReactElement } from 'react';
import classNames from 'classnames/bind';
import Link from 'next/link';
import useWindowSize from 'utils/hooks/useWindowSize';
import styles from 'sections/DigitalTools/LogisticsExplorer/components/SectionWidgets/SectionWidgets.module.scss';

const cn = classNames.bind(styles);

const SectionWidgets = (): ReactElement => {
  const { width: screenWidth } = useWindowSize();

  return (
    <section className={cn('cta')}>
      <div className={cn('container')}>
        <div className={cn('cta__box')}>
          <h2 className={cn('cta__heading')}>
            Multiple Widget Templates
          </h2>
          <p className={cn('cta__description')}>
            {screenWidth > 769 &&
              <>
                <span>Our Logistics Explorer tool comes with customisable configurations</span>{' '}
                <span>to complement a wide range of website requirements, from compact</span>{' '}
                <span>components to comprehensive, full-page interfaces.</span>
              </>
            }
            {screenWidth <= 769 &&
              <>
                Our Logistics Explorer tool comes with customisable configurations to 
                complement a wide range of website requirements, from compact components 
                to comprehensive, full-page interfaces.
              </>
            }
          </p>
          <div className={cn('cta__buttons')}>
            <Link
              className={cn('cta__button-discover')}
              href="https://www.searates.com/tools#search-filter"
            >
              Try Widget on My Website
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SectionWidgets;